export const ISSUES_PAGE_CONSTANTS = {
	TITLE: {
		ALL: 'All issues',
		UNIQUE: 'Unique issues'
	},
	DESCRIPTION: {
		ALL: 'Every occurrence of an accessibility issue across the product is counted.',
		UNIQUE: 'Only the unique occurrences of accessibility issues are counted.'
	},
	BACK_BUTTON_TEXT: 'Back to Dashboard'
};
